export default "__VITE_ASSET__CbSsiTiX__"